import { useMemo } from "react";
import ShiftTrade from "../../components/drawers/ShiftTrade";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useShiftTradeDrawer = () => {
    const { visible, open, close, selected } = useVisible();

    const drawer = useMemo(() => {
        return (
            <ShiftTrade 
                isOpen={visible}
                close={close}
                values={selected}
            />
        );
    }, [visible, close, selected]);

    return { open, drawer };
}
